import { render, staticRenderFns } from "./RoundDates.vue?vue&type=template&id=2d3db10c"
import script from "./RoundDates.vue?vue&type=script&lang=js"
export * from "./RoundDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports